<template>
  <AppAside class="aside-for-terms">
    <template v-slot:title>
      <h1>Please review and agree to the following terms before submitting your request to update the communication preference.</h1>
    </template>
    <ul class="app-bullet-list">
      <li>
        I have reviewed my mailing address and Contact information mentioned above and confirm that the information is correct
      </li>
      <li>
        I confirm that I will update RI DMV immediately if there is any change to my mailing address and / or contact information
      </li>
    </ul>
    <div class="app-input-group" ref="agreementCheck">
      <div class="app-checker-group">
        <input type="checkbox" id="agreed" v-model="isAgreed">
        <label for="agreed">
          I have read, understand and agree to the above terms.
        </label>
      </div>
      <p class="error" hidden ref="noAgreement">You must accept the Terms and Conditions to continue.</p>
    </div>
  </AppAside>
</template>

<script setup>
import { ref, watch } from 'vue';
import AppAside from './AppAside.vue';

// Props 
const props = defineProps({
  verify: {
    type: Boolean,
    required: true,
  }
});

// Emits
const emit = defineEmits(['doValidated', 'doResetVerify']);

const isAgreed = ref(false);
const agreementCheck = ref(null);
const noAgreement = ref(null);

// Methods
const toggleAgreementCheck = () => {
  if (isAgreed.value) {
    noAgreement.value.setAttribute('hidden', 'hidden');
    agreementCheck.value.classList.remove('app-invalid-group');
  } else {
    noAgreement.value.removeAttribute('hidden');
    agreementCheck.value.classList.add('app-invalid-group');
  }
}

// Watcher 
watch(isAgreed, () => {
  toggleAgreementCheck();
});

watch(() => props.verify, (newVal) => {
  if (newVal) {
    toggleAgreementCheck();
    if (isAgreed.value) {
      emit('doValidated');
    } else {
      emit('doResetVerify');
    }
  }
});
</script>


<style scoped lang="scss">
.app-notice {
  max-width: unset;
}
.aside-for-terms {
  flex-grow: 1;
  margin-bottom: 2em;
  .app-input-group {
    margin-top: 1em;
    margin-left: 1.25em;
  }
}
</style>
